import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Alert, Snackbar } from "@mui/material";
import { Box } from "@mui/system";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import style from "./Notifications.module.css";

const Notifications = () => {
  const [snackOpen, setSnackOpen] = useState(false);
  const [notification, setNotification] = useState({});
  const [showDetails, setShowDetails] = useState(false);
  const notifications = useSelector(
    (state) => state.workshops.status.notifications
  );

  //when the notifications array changes show the latest addition to the array
  useEffect(() => {
    if (notifications.length > 1) {
      //get the last notification from the array
      setNotification(notifications[notifications.length - 1]);
      showSnackBar();
    }
  }, [notifications]);

  const showSnackBar = () => {
    setSnackOpen(true);
  };

  const hideSnackBar = () => {
    setSnackOpen(false);
    setShowDetails(false);
  };

  return (
    <Snackbar
      open={snackOpen}
      autoHideDuration={notification.type === "error" ? 10000 : 3000} //on error show the notification longer
      onClose={hideSnackBar}
      anchorOrigin={{ vertical: "top", horizontal: "center" }}
    >
      <Alert
        onClose={hideSnackBar}
        severity={notification.type}
        sx={{ width: "100%" }}
        variant="filled"
      >
        <Box className={style.title}>{notification.message}</Box>
        {notification?.details && (
          <>
            <Box
              className={style.more}
              onClick={() => {
                setShowDetails(!showDetails);
              }}
              sx={{ cursor: "pointer" }}
            >
              {showDetails ? (
                <>
                  Hide details <ExpandLessIcon />
                </>
              ) : (
                <>
                  Show details <ExpandMoreIcon />
                </>
              )}
            </Box>
            {showDetails && (
              <Box className={style.details}>{notification.details}</Box>
            )}
          </>
        )}
      </Alert>
    </Snackbar>
  );
};

export default Notifications;
